import React, { useMemo } from "react";
import stringify from "fast-json-stable-stringify";

import { formatNumber } from "@formant/core/common/formatNumber";
import { IFilter } from "@formant/core/model/IFilter";
import { Badge } from "@formant/ui-kit";
import { cn } from "@formant/ui-kit/src/lib/utils";

import { useLiveEventCounts } from "../../utils/useLiveEventCounts";

export interface IProps {
    filter: IFilter;
    onClick: () => void;
}
export const FleetEventBadge = (props: IProps) => {
    const { filter, onClick } = props;

    // filter should never contain names for event count
    const { names, ...filterWithoutNames } = filter;
    const eventFilter = useMemo(
        () => ({
            ...filterWithoutNames,
            viewed: false,
            disableNullMatches: true,
            notificationEnabled: true,
        }),
        [stringify(filterWithoutNames)],
    );

    const counts = useLiveEventCounts(eventFilter);
    const {
        info,
        warning,
        error,
        critical,
        "triggered-event": triggeredEvents,
        "intervention-request": interventions,
        custom,
        stateful,
    } = {
        info: 0,
        warning: 0,
        error: 0,
        critical: 0,
        "triggered-event": 0,
        "intervention-request": 0,
        custom: 0,
        stateful: 0,
        ...counts,
    };

    const notifications = triggeredEvents + interventions + custom + stateful;

    const variant =
        critical > 0
            ? "critical"
            : error > 0
              ? "error"
              : warning > 0
                ? "warning"
                : info > 0
                  ? "info"
                  : "open";

    if (notifications === 0) {
        return null;
    }

    return (
        <Badge
            variant={variant}
            onClick={e => {
                e.stopPropagation();
                onClick();
            }}
            data-testid="device-events-notification"
            className={cn(" font-normal rounded-full")}
        >
            {formatNumber(notifications)}
        </Badge>
    );
};
